import InstallationPlatforms from "../../../../contents/docs/error-tracking/installation/_snippets/installation-platforms";
import { QuestLog, QuestLogItem } from 'components/Docs/QuestLog';
import { IconGraph, IconRewindPlay, IconToggle } from '@posthog/icons';
import OSButton from 'components/OSButton';
import * as React from 'react';
export default {
  InstallationPlatforms,
  QuestLog,
  QuestLogItem,
  IconGraph,
  IconRewindPlay,
  IconToggle,
  OSButton,
  React
};